import { render, staticRenderFns } from "./NewSlotSimpleForm.vue?vue&type=template&id=0aeb8e44"
import script from "./NewSlotSimpleForm.vue?vue&type=script&lang=js"
export * from "./NewSlotSimpleForm.vue?vue&type=script&lang=js"
import style0 from "./NewSlotSimpleForm.vue?vue&type=style&index=0&id=0aeb8e44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports